import Marquee from "react-fast-marquee";

const PIECES = [
  "AMI ONE",
  "BORIVALI WEST",
  "BOUTIQUE RESIDENCES",
  "SAMPLE APARTMENT READY",
  "G+10 · 2 PER FLOOR",
  "MAJITHIA BROTHERS",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-ivory/[0.08] bg-ink-900/40 py-6 md:py-8 overflow-hidden"
    >
      <Marquee gradient={false} speed={45} pauseOnHover>
        {PIECES.concat(PIECES).map((p, i) => (
          <span
            key={i}
            className="mx-8 md:mx-14 inline-flex items-center gap-6 md:gap-10 font-serif italic text-3xl md:text-5xl lg:text-6xl text-ivory/85"
          >
            {p}
            <span className="text-copper text-xl md:text-3xl not-italic">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
